import { Fragment } from 'react'
import styles from './JourneyStrip.module.css'

const JOURNEY_PLATFORMS = [
  { bg: 'linear-gradient(135deg,#E8642A,#f5945c)', letter: 'S', name: 'SkillNexus',  desc: 'Learn in-demand skills' },
  { bg: 'linear-gradient(135deg,#0891b2,#22d3ee)', letter: 'I', name: 'InternNexus', desc: 'Real-world internships' },
  { bg: 'linear-gradient(135deg,#1C2D5E,#3a5cb8)', letter: 'P', name: 'PromptNexus', desc: 'AI challenges & hackathons' },
]

export default function JourneyStrip() {
  return (
    <div className={styles.strip} aria-label="Platform journey overview">
      <div className={styles.inner}>
        {JOURNEY_PLATFORMS.map((p, i) => (
          <Fragment key={p.name}>
            <div className={styles.step}>
              <div className={styles.icon} style={{ background: p.bg }}>{p.letter}</div>
              <p className={styles.name}>{p.name}</p>
              <p className={styles.desc}>{p.desc}</p>
            </div>
            {i < JOURNEY_PLATFORMS.length - 1 && (
              <span className={styles.arrow} aria-hidden="true">→</span>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  )
}
